// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OpponentVideoItem__video-container-d56e1a {
  margin-bottom: 8px;
  width: 220px;
  min-height: 131px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.OpponentVideoItem__video-container-d56e1a video {
  object-fit: cover;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/SpeakerVideo/OpponentList/components/OpponentVideoItem/OpponentVideoItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,iBAAA;EACA,YAAA;AACF","sourcesContent":[".video-container {\n  margin-bottom: 8px;\n  width: 220px;\n  min-height: 131px;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n}\n\n.video-container video {\n  object-fit: cover;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-container": `OpponentVideoItem__video-container-d56e1a`,
	"videoContainer": `OpponentVideoItem__video-container-d56e1a`
};
module.exports = ___CSS_LOADER_EXPORT___;
